import { render, staticRenderFns } from "./ClassifyQuestionDetail.vue?vue&type=template&id=706f388d&scoped=true&"
import script from "./ClassifyQuestionDetail.vue?vue&type=script&lang=js&"
export * from "./ClassifyQuestionDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClassifyQuestionDetail.vue?vue&type=style&index=0&id=706f388d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706f388d",
  null
  
)

export default component.exports